import React, { useState, useEffect } from 'react';
import { Router, Switch, Route } from 'react-router-dom';
import { Spin } from 'antd';
import ReactTracker from 'react-tracker-teko';
import { browserHistory, iframeHelpers } from 'helpers';
import './App.less';
import './App.scss';
import Page403 from 'containers/shared/Page403';
import Page404 from 'containers/shared/Page404';
import Page500 from 'containers/shared/Page500';
import PrivateRoute from 'components/shared/PrivateRoute';
import AppLayout from 'containers/AppLayout';
import { PATH } from './routes/constants';
import { userServices, orgchartService } from './services';
import { useThunkDispatch } from './helpers/common';
import { updateOrgChartStaffInfo } from './actions/Orgchart/actions';
import { localStorageConstants } from 'constants/index';
import AppRibbon from './components/AppRibbon';
import { QueryCache, ReactQueryCacheProvider } from 'react-query';
import SPOS_DISPLAY_OPTIONS from './constants/spos';

const { COMPANY_ID, ROLE_TITLE, DISPLAY_OPTIONS } = localStorageConstants;

const { tracker } = window.config;

const { inIframe } = iframeHelpers;

const queryCache = new QueryCache({
  defaultConfig: {
    queries: {
      refetchOnMount: false,
      refetchOnWindowFocus: false,
      refetchOnReconnect: false,
      retry: false,
    },
  },
});

const reactTracker = new ReactTracker({
  // Configure your tracker server and site by providing

  host: (tracker.appId && tracker.host) || '',
  urlServeJsFile: (tracker.appId && tracker.jsFile) || '',
  appId: tracker.appId,
});

const App: React.FC = () => {
  const dispatch = useThunkDispatch();
  if (userServices.isLoggedIn()) {
    let prevPath = localStorage.getItem('PREV_PATH');
    if (prevPath) {
      localStorage.removeItem('PREV_PATH');
      browserHistory.push(prevPath);
    }
  }
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true);
    orgchartService
      .getUserInfo()
      .then(value => {
        const { data } = value;
        dispatch(updateOrgChartStaffInfo(data.staff));
        localStorage.setItem(COMPANY_ID, data.staff.companyId.toString());
        localStorage.setItem(
          ROLE_TITLE,
          data.staff.department.roleTitle.toString()
        );
        localStorage.setItem(
          DISPLAY_OPTIONS,
          JSON.stringify(SPOS_DISPLAY_OPTIONS)
        );
        setLoading(false);
      })
      .catch(error => {
        if (error.response && error.response.data.code === '121')
          browserHistory.push('/403');
        setLoading(false);
      });
  }, []);

  return loading ? (
    <Spin className="app-spin" />
  ) : (
    <Router history={reactTracker.connectToHistory(browserHistory)}>
      <Switch>
        <Route exact path="/403" name="403" component={Page403} />
        <Route exact path="/404" name="404" component={Page404} />
        <Route exact path="/500" name="500" component={Page500} />
        <PrivateRoute path={PATH.HOME} component={AppLayout} />
      </Switch>
    </Router>
  );
};

const AppContainer = () => {
  return (
    <ReactQueryCacheProvider queryCache={queryCache}>
      {!inIframe() && <AppRibbon />}
      <App />
    </ReactQueryCacheProvider>
  );
};

export default AppContainer;
